import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    UtenteAutenticato: false,
    UtentePartner: false,
    UtenteAmministratore: false,
    ServerURL: "",
    LocalURL: "",
    Utente: "",
    Password: "",
    Struttura: "",
    DescrizioneStruttura: "",
    Applicazione: "",
    Lingua: "IT",
    EmailFacileCheckIn: "administrator@checkin.loquos.it",
    SelectPlain: true,
    PathToLoadAfterLogin: "",
  /* eslint-disable-next-line no-control-regex */
  /* eslint-disable-next-line no-useless-escape */
  PatternEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PatternCodiceStruttura: /^[A-Z|a-z|0-9|\-|_]+$/

  },
  mutations: {
    SettaUtenteAutenticato(state, UtenteAutenticato) {
      state.UtenteAutenticato = UtenteAutenticato;
    },
    SettaPartner(state, UtentePartner) {
      state.UtentePartner = UtentePartner;
    },
    SettaAmministratore(state, UtenteAmministratore) {
      state.UtenteAmministratore = UtenteAmministratore;
    },
    SettaServerURL(state, ServerURL) {
      state.ServerURL = ServerURL;
    },
    SettaLocalURL(state, LocalURL) {
      state.LocalURL = LocalURL;
    },
    SettaUtente(state, Utente) {
      state.Utente = Utente;
    },
    SettaPassword(state, Password) {
      state.Password = Password;
    },
    SettaStruttura(state, Struttura) {
      state.Struttura = Struttura;
    },
    SettaDescrizioneStruttura(state, DescrizioneStruttura) {
      state.DescrizioneStruttura = DescrizioneStruttura;
    },
    SettaApplicazione(state, Applicazione) {
      state.Applicazione = Applicazione;
    },
    SettaLingua(state, Lingua) {
      state.Lingua = Lingua;
    },
    SettaEmailFacileCheckIn(state, Email) {
      state.EmailFacileCheckIn = Email;
    },
    SettaSelectPlain(state, SelectPlain) {
      state.SelectPlain = SelectPlain;
    },
    SettaPathToLoadAfterLogin(state, PathToLoadAfterLogin){
      state.PathToLoadAfterLogin = PathToLoadAfterLogin;
    }
  },
  actions: {
  },
  modules: {
  }
})
